export const theme = {
    colors: {
        black: '#000',
        secondary: '#878282',
        white: '#fff',
        lightGray: '#faf5f5',
        accent: '#2f7f8a',
        muted: '#f6f6f6',
      },
      fonts: {
        body: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
        heading: 'Georgia, serif',
        monospace: 'Menlo, monospace',
      },
      fontWeights: {
        body: 400,
        heading: 700,
        bold: 700,
      },
      lineHeights: {
        body: 1.5,
        heading: 1.125,
      },
      fontSizes: [
        12, 14, 16, 20, 24, 32, 48, 64,
      ],
      space: [0, 2, 4, 8, 16, 32, 64, 128, 256,],
      borders: {
        none: 'none',
        normal: '1px solid',
      },
      radii: {
        none: '0',
        normal: '4px',
        round: '50%',
      },
}